import { toPairs } from "lodash-es";

export const roleArr = [
  "Gymnasium.SuperAdmin",
  "Gymnasium.MunicipalityAdmin",
  "Gymnasium.MunicipalityUser",
  "Gymnasium.SchoolAdmin",
  "Gymnasium.SchoolUser",
];

export const roles = {
  SuperAdmin: "Gymnasium.SuperAdmin",
  MunicipalityAdmin: "Gymnasium.MunicipalityAdmin",
  MunicipalityUser: "Gymnasium.MunicipalityUser",
  SchoolAdmin: "Gymnasium.SchoolAdmin",
  SchoolUser: "Gymnasium.SchoolUser",
};

export const roleLabels = {
  [roles.SuperAdmin]: "Superadmin",
  [roles.MunicipalityAdmin]: "Kommunadmin",
  [roles.MunicipalityUser]: "Kommunanvändare",
  [roles.SchoolAdmin]: "Skoladmin",
  [roles.SchoolUser]: "Skolanvändare",
};
export const roleLabelsEn = {
  [roles.SuperAdmin]: "Super Admin",
  [roles.MunicipalityAdmin]: "Municipal Admin",
  [roles.MunicipalityUser]: "Municipal Users",
  [roles.SchoolAdmin]: "School Admin",
  [roles.SchoolUser]: "School Users",
};
export const roleOptions = toPairs(roleLabels).map(([value, label]) => ({
  value,
  label,
}));
export const roleOptionsEn = toPairs(roleLabelsEn).map(([value, label]) => ({
  value,
  label,
}));
